// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Fundraisers_container__6QU8z{
    display: flex;
    min-height: calc(100vh - 230px);
    margin-top: 20px;
    margin-bottom: 20px;
    padding-bottom: 20px;
    background-color: #FFFFFF;
    border-radius: 30px;
    box-shadow: 0 3px 12px 0 #40798C12;
}
.Fundraisers_fundraisers__ljq6X{
    width: 100%;
    padding-left: 35px;
    padding-right: 35px;
}
@media(max-width: 1320px){
    .Fundraisers_fundraisers__ljq6X{
        width: calc(100% - 70px);
    }
}
@media(max-width: 600px){
    .Fundraisers_fundraisers__ljq6X{
        width: calc(100% - 40px);
        padding-left: 20px;
        padding-right: 20px;
    }
}
.Fundraisers_topSection__ngzyt{
    display: flex;
    align-items: baseline;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
}
@media(max-width: 1000px){
    .Fundraisers_topSection__ngzyt{
        flex-wrap: wrap;
    }
}
.Fundraisers_fundraisersHeader__0nGx2{
    text-align: left;
}
.Fundraisers_bottomSection__S8Cd9{
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
}
@media(max-width: 1400px){
    .Fundraisers_bottomSection__S8Cd9{
        justify-content: center;
    }
}
.Fundraisers_fundraiser__wIBW5{
    margin-bottom: 35px;
}
.Fundraisers_fundraiser__wIBW5:not(:last-of-type){
    margin-right: 30px;
}
@media(max-width: 1400px){
    .Fundraisers_fundraiser__wIBW5{
        width: calc(50% - 66px) !important;
    }
    .Fundraisers_fundraiser__wIBW5:nth-of-type(even){
        margin-right: 0;
    }
}
@media(max-width: 1320px){
    .Fundraisers_fundraiser__wIBW5{
        width: calc(33% - 68px) !important;
    }
    .Fundraisers_fundraiser__wIBW5:nth-of-type(even){
        margin-right: 30px;
    }
    .Fundraisers_fundraiser__wIBW5:nth-of-type(3n), .Fundraisers_fundraiser__wIBW5:last-of-type{
        margin-right: 0;
    }
}
@media(max-width: 1200px){
    .Fundraisers_fundraiser__wIBW5{
        width: calc(50% - 66px) !important;
    }
    .Fundraisers_fundraiser__wIBW5:nth-of-type(even){
        margin-right: 0;
    }
    .Fundraisers_fundraiser__wIBW5:nth-of-type(3n){
        margin-right: auto;
    }
}
@media(max-width: 820px){
    .Fundraisers_fundraiser__wIBW5{
        width: calc(100% - 48px) !important;
        margin-bottom: 25px;
        margin-right: 0 !important;
    }
}
.Fundraisers_rightSide__gZM\\+h{
    display: flex;
    position: relative;
    top: -8px;
    margin-left: auto;
}
@media(max-width: 600px){
    .Fundraisers_rightSide__gZM\\+h{
        margin-top: 10px;
    }
}
.Fundraisers_searchInput__q4J\\+V{
    margin-right: 20px;
}
@media(max-width: 1000px){
    .Fundraisers_rightSide__gZM\\+h{
        width: 100%;
    }
    .Fundraisers_searchInput__q4J\\+V{
        width: calc(100% - 335px);
    }
    .Fundraisers_searchInput__q4J\\+V > div{
        width: 100%;
    }
    .Fundraisers_searchInput__q4J\\+V input{
        width: calc(100% - 80px);
    }
}
.Fundraisers_searchFilter__zG7iH{
    margin-left: auto;
    margin-right: 15px;
}
.Fundraisers_searchOrder__eJVL\\+{
    margin-left: auto;
}
@media(max-width: 560px){
    .Fundraisers_rightSide__gZM\\+h{
        flex-wrap: wrap;
    }
    .Fundraisers_searchInput__q4J\\+V{
        display: block;
        width: 100%;
        margin-right: 0;
    }
    .Fundraisers_searchFilter__zG7iH, .Fundraisers_searchOrder__eJVL\\+{
        width: calc(50% - 5px);
        margin-top: 12px;
        margin-left: 0;
    }
    .Fundraisers_searchFilter__zG7iH{
        margin-right: 10px;
    }
}
.Fundraisers_noFundraisers__q2Kfu{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin-top: 50px;
}
.Fundraisers_magnifyingGlassWithQuestionMark__1LIHd{
    height: 60px;
    width: 60px;
}
.Fundraisers_noFundraisersDescription__LpC8z{
    margin-top: 35px;
    color: #1F363D;
    text-align: center;
    font-size: 31px;
    font-family: 'Gotham Bold', serif;
}
.Fundraisers_noFundraisersButton__7RubV{
    width: 150px;
    margin-top: 50px;
    margin-bottom: 30px;
    padding: 4px 20px;
    color: #FFFFFF;
    background-color: #40798C;
    font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Fundraisers.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,wBAAwB;QACxB,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI;QACI,kCAAkC;IACtC;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,kCAAkC;IACtC;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,kCAAkC;IACtC;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,mCAAmC;QACnC,mBAAmB;QACnB,0BAA0B;IAC9B;AACJ;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,iBAAiB;AACrB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,kBAAkB;AACtB;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,WAAW;IACf;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,cAAc;QACd,WAAW;QACX,eAAe;IACnB;IACA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,eAAe;AACnB","sourcesContent":[".container{\n    display: flex;\n    min-height: calc(100vh - 230px);\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding-bottom: 20px;\n    background-color: #FFFFFF;\n    border-radius: 30px;\n    box-shadow: 0 3px 12px 0 #40798C12;\n}\n.fundraisers{\n    width: 100%;\n    padding-left: 35px;\n    padding-right: 35px;\n}\n@media(max-width: 1320px){\n    .fundraisers{\n        width: calc(100% - 70px);\n    }\n}\n@media(max-width: 600px){\n    .fundraisers{\n        width: calc(100% - 40px);\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n}\n.topSection{\n    display: flex;\n    align-items: baseline;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n}\n@media(max-width: 1000px){\n    .topSection{\n        flex-wrap: wrap;\n    }\n}\n.fundraisersHeader{\n    text-align: left;\n}\n.bottomSection{\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 20px;\n}\n@media(max-width: 1400px){\n    .bottomSection{\n        justify-content: center;\n    }\n}\n.fundraiser{\n    margin-bottom: 35px;\n}\n.fundraiser:not(:last-of-type){\n    margin-right: 30px;\n}\n@media(max-width: 1400px){\n    .fundraiser{\n        width: calc(50% - 66px) !important;\n    }\n    .fundraiser:nth-of-type(even){\n        margin-right: 0;\n    }\n}\n@media(max-width: 1320px){\n    .fundraiser{\n        width: calc(33% - 68px) !important;\n    }\n    .fundraiser:nth-of-type(even){\n        margin-right: 30px;\n    }\n    .fundraiser:nth-of-type(3n), .fundraiser:last-of-type{\n        margin-right: 0;\n    }\n}\n@media(max-width: 1200px){\n    .fundraiser{\n        width: calc(50% - 66px) !important;\n    }\n    .fundraiser:nth-of-type(even){\n        margin-right: 0;\n    }\n    .fundraiser:nth-of-type(3n){\n        margin-right: auto;\n    }\n}\n@media(max-width: 820px){\n    .fundraiser{\n        width: calc(100% - 48px) !important;\n        margin-bottom: 25px;\n        margin-right: 0 !important;\n    }\n}\n.rightSide{\n    display: flex;\n    position: relative;\n    top: -8px;\n    margin-left: auto;\n}\n@media(max-width: 600px){\n    .rightSide{\n        margin-top: 10px;\n    }\n}\n.searchInput{\n    margin-right: 20px;\n}\n@media(max-width: 1000px){\n    .rightSide{\n        width: 100%;\n    }\n    .searchInput{\n        width: calc(100% - 335px);\n    }\n    .searchInput > div{\n        width: 100%;\n    }\n    .searchInput input{\n        width: calc(100% - 80px);\n    }\n}\n.searchFilter{\n    margin-left: auto;\n    margin-right: 15px;\n}\n.searchOrder{\n    margin-left: auto;\n}\n@media(max-width: 560px){\n    .rightSide{\n        flex-wrap: wrap;\n    }\n    .searchInput{\n        display: block;\n        width: 100%;\n        margin-right: 0;\n    }\n    .searchFilter, .searchOrder{\n        width: calc(50% - 5px);\n        margin-top: 12px;\n        margin-left: 0;\n    }\n    .searchFilter{\n        margin-right: 10px;\n    }\n}\n.noFundraisers{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    margin-top: 50px;\n}\n.magnifyingGlassWithQuestionMark{\n    height: 60px;\n    width: 60px;\n}\n.noFundraisersDescription{\n    margin-top: 35px;\n    color: #1F363D;\n    text-align: center;\n    font-size: 31px;\n    font-family: 'Gotham Bold', serif;\n}\n.noFundraisersButton{\n    width: 150px;\n    margin-top: 50px;\n    margin-bottom: 30px;\n    padding: 4px 20px;\n    color: #FFFFFF;\n    background-color: #40798C;\n    font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Fundraisers_container__6QU8z`,
	"fundraisers": `Fundraisers_fundraisers__ljq6X`,
	"topSection": `Fundraisers_topSection__ngzyt`,
	"fundraisersHeader": `Fundraisers_fundraisersHeader__0nGx2`,
	"bottomSection": `Fundraisers_bottomSection__S8Cd9`,
	"fundraiser": `Fundraisers_fundraiser__wIBW5`,
	"rightSide": `Fundraisers_rightSide__gZM+h`,
	"searchInput": `Fundraisers_searchInput__q4J+V`,
	"searchFilter": `Fundraisers_searchFilter__zG7iH`,
	"searchOrder": `Fundraisers_searchOrder__eJVL+`,
	"noFundraisers": `Fundraisers_noFundraisers__q2Kfu`,
	"magnifyingGlassWithQuestionMark": `Fundraisers_magnifyingGlassWithQuestionMark__1LIHd`,
	"noFundraisersDescription": `Fundraisers_noFundraisersDescription__LpC8z`,
	"noFundraisersButton": `Fundraisers_noFundraisersButton__7RubV`
};
export default ___CSS_LOADER_EXPORT___;
